<template>
  <ax-dialog 
    ref="dialog"
    title="Filter" 
    icon="mdi-plus" 
    tooltip="Filter" 
    size="medium" 
    tile 
    @submitted="onSubmit" 
    :disabled="disabled"
  >
    <template slot="content">
      <v-card-text>
        <v-row>
          <v-col cols="auto">
            <v-autocomplete
              label="File" 
              :items="files"
              v-model="filter.file"
              item-text="value"
              item-value="id"
              no-data-text="Please select completions or production files first"
            />
          </v-col>
          <v-col>
            <v-autocomplete label="Column" :items="columns[filter.file]" v-model="filter.column" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="auto">
            <v-checkbox label="not" v-model="filter.negation" />
          </v-col>
          <v-col cols="auto">
            <v-autocomplete label="Operator" :items="operators" v-model="filter.operator" />
          </v-col>
          <v-col>
            <v-autocomplete v-if="uniques.length > 0" label="Value" :items="uniques" v-model="filter.value" multiple />
            <v-text-field v-else label="Value" v-model="filter.value" />
          </v-col>
        </v-row>
      </v-card-text>
    </template>
  </ax-dialog>
</template>
<script>
import AxDialog from "@/components/dialog"
import Files from "@/api/files"
export default {
  name: "Filters",
  props: {
    dataset: { type: Object, required: true },
    files: { type: Array, required: true },
    columns: { type: Object, required: true },
    disabled: { type: Boolean, default: false }
  },
  components: {
    AxDialog
  },
  data() {
    return {
      filter: {
        file: null,
        column: null,
        negation: false,
        operator: null,
        value: []
      },
      operators: ["in", "equals", "contains", "is less than", "is greater than"],
      uniques: []
    }
  },
  computed: {
    isValidFilter() {
      return !!this.filter.file && !!this.filter.column && !!this.filter.operator && this.filter.value.length > 0
    },
  },
  watch: {
    "filter.column": function(val) {
      if (val) {
        Files.uniques(this.dataset[this.filter.file].uuid, val).then(response => (this.uniques = response.data))
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.dialog.show = false
      this.$emit('submitted', this.filter)
      this.filter = {
        file: null,
        column: null,
        negation: false,
        operator: null,
        value: []
      }
    }
  }
}
</script>